import { AssetSvgProps } from "../../../shared/assets"

export const defaultColors = {
    "col1n": "#000000"
}
function FacBro031({ colors = defaultColors, className, onClick, outerTransform, transform, startDrag }: AssetSvgProps) {
    return (
        <g transform={outerTransform}><g className={className} onClick={onClick} transform={transform} onMouseDown={startDrag} onTouchStart={startDrag}><defs>
                <path
                    fill={colors.col1n}
                    d="M51.2 24.4q0-10.1-7.55-17.3Q36.15 0 25.6 0 15 0 7.5 7.1 0 14.3 0 24.4v.5q0 .35.3.65.25.25.6.25t.65-.25q.25-.3.25-.65v-.5q0-9.3 6.95-16Q15.7 1.8 25.6 1.8q9.85 0 16.8 6.6 7 6.7 7 16v.5q0 .35.3.65.25.25.6.25t.65-.25q.25-.3.25-.65v-.5m51.2-16q7 6.7 7 16v.5q0 .35.3.65.25.25.6.25t.65-.25q.25-.3.25-.65v-.5q0-10.1-7.55-17.3Q96.1 0 85.55 0T67.5 7.1Q60 14.3 60 24.4v.5q0 .35.3.65.25.25.6.25t.65-.25q.25-.3.25-.65v-.5q0-9.3 6.95-16 6.95-6.6 16.8-6.6 9.85 0 16.85 6.6z"
                    id="FacBro031__Symbol_32_0_Layer0_0_FILL"
                />
            </defs>
            <use
                xlinkHref="#FacBro031__Symbol_32_0_Layer0_0_FILL"
                transform="translate(136.9 97.35)"
                id="FacBro031__col1n"
            />
        </g></g>
    )
}
export default FacBro031
